/**
 * QuickCalm — top-level orchestrator.
 *
 * Composes:
 *   - <FloatingTrigger />  the draggable floating button
 *   - <CalmModal />        the breath/audio modal
 *
 * The cyclomatic complexity-40 monolith this replaces (~355 lines) has been
 * split into:
 *   - components/quickcalm/FloatingTrigger.js   ~80 lines, complexity ~3
 *   - components/quickcalm/CalmModal.js        ~120 lines, complexity ~5
 *   - components/quickcalm/BreathCircle.js      ~55 lines, complexity ~3
 *   - components/quickcalm/useBreathCycle.js    ~70 lines (hook)
 *   - components/quickcalm/useCalmAudio.js      ~60 lines (hook)
 *   - this file                                  <30 lines, complexity ~2
 */
import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import FloatingTrigger from './quickcalm/FloatingTrigger';
import CalmModal from './quickcalm/CalmModal';

const QuickCalm = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <FloatingTrigger onOpen={() => setIsOpen(true)} />
      <AnimatePresence>
        {isOpen && <CalmModal onClose={() => setIsOpen(false)} />}
      </AnimatePresence>
    </>
  );
};

export default QuickCalm;
